import { render } from "./UsernamePasswordLogin.vue?vue&type=template&id=3c361472&scoped=true"
import script from "./UsernamePasswordLogin.vue?vue&type=script&lang=js"
export * from "./UsernamePasswordLogin.vue?vue&type=script&lang=js"

import "./UsernamePasswordLogin.vue?vue&type=style&index=0&id=3c361472&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c361472"]])

export default __exports__